import {
  getCustomerInfoEvaluation,
  saveEvaluate,
  getEvaluateContent
} from '@/api/checkEvaluation'

const state = {}

const mutations = {}

const actions = {

  getCustomerInfoEvaluation({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getCustomerInfoEvaluation(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveEvaluate({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      saveEvaluate(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEvaluateContent({ commit }, pageData) {
    return new Promise((resolve, reject) => {
      getEvaluateContent(pageData).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
